// extracted by mini-css-extract-plugin
export default {"fileNameWrapper":"ProjectsNavigation_fileNameWrapper__GoOwE","h2":"ProjectsNavigation_h2__bTkik"};